import { Col, Row, Card, Icons, Typography, Show, notification } from '@pankod/refine-antd';
import { IFindCounts } from 'interfaces';
import { useEffect, useState } from 'react';
import { getDashboardCounts } from 'services/dashboard';
import { PosNavigationMenu } from './PosNavigationMenu';
import './dashboard-cards.css';
const { Text, Title } = Typography;

type InfoCardProps = {
  name: string;
  amount: number;
};

export const DashboardCards: React.FC<InfoCardProps> = (props) => {
  const [findCounts, setFindCounts] = useState<IFindCounts>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const data = await getDashboardCounts();
        setFindCounts(data);
      } catch (err) {
        if (err instanceof Error) {
          notification.error({
            message: 'Failed',
            description: err.message,
          });
        }
      }
      setIsLoading(false);
    })();
  }, [props.name]);

  return (
    <Show title="" pageHeaderProps={{ extra: null }} isLoading={isLoading}>
      <Row gutter={[16, 16]}>
        <Col xl={6} lg={6} md={12} sm={24} xs={24}>
          <InfoCard name="Suppliers" amount={findCounts?.supplier || 0}>
            <Icons.TeamOutlined style={{ fontSize: '32px' }} />
          </InfoCard>
        </Col>
        <Col xl={6} lg={6} md={12} sm={24} xs={24}>
          <InfoCard name="Warehouse" amount={findCounts?.warehouse || 0}>
            <Icons.HomeOutlined style={{ fontSize: '32px' }} />
          </InfoCard>
        </Col>
        <Col xl={6} lg={6} md={12} sm={24} xs={24}>
          <InfoCard name="Products" amount={findCounts?.product || 0}>
            <Icons.ShopOutlined style={{ fontSize: '32px' }} />
          </InfoCard>
        </Col>
        <Col xl={6} lg={6} md={12} sm={24} xs={24}>
          <InfoCard name="User" amount={findCounts?.user || 0}>
            <Icons.UserOutlined style={{ fontSize: '32px' }} />
          </InfoCard>
        </Col>
      </Row>
      <br />
      <Row gutter={[16, 16]}>
        <Col xl={6} lg={6} md={12} sm={24} xs={24}>
          <InfoCard name="Purchases" amount={findCounts?.purchase || 0}>
            <Icons.MoneyCollectOutlined style={{ fontSize: '32px' }} />
          </InfoCard>
        </Col>
        <Col xl={6} lg={6} md={12} sm={24} xs={24}>
          <InfoCard name="Sales" amount={findCounts?.sales || 0}>
            <Icons.StockOutlined style={{ fontSize: '32px' }} />
          </InfoCard>
        </Col>
      </Row>
      <PosNavigationMenu />
    </Show>
  );
};

const InfoCard: React.FC<InfoCardProps> = (props) => {
  return (
    <Card
      style={{
        backgroundColor: '#ffffff',
        boxShadow: '-2px 5px 12px -8px rgb(0 0 0 / 15%)',
      }}
    >
      <div
        className="dashboard-card-content"
        style={{
          height: '70px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div className="dashboard-card-text">
          <Title className="dashboard-card-title" level={5} style={{ marginBottom: '0px' }}>
            {props.name}
          </Title>
          <Text className="dashboard-card-count" strong style={{ fontSize: '24px' }}>
            {props.amount}
          </Text>
        </div>
        <div className="dashboard-card-icon">{props.children}</div>
      </div>
    </Card>
  );
};
